export const convertMsToHumanTime = (ms: number, timeFormat: 'minutes' | 'seconds' | 'hours' = 'minutes'): string => {
    const seconds = ms / 1000;
    let result = '';

    if (timeFormat === 'seconds') {
        if (seconds > 0) {
            result += `${seconds}`;
            result += ` second${seconds > 1 ? 's' : ''}`;
        }
    }

    if (timeFormat === 'minutes') {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;

        if (minutes > 0) {
            result += `${minutes}`;
            result += ` minute${minutes > 1 ? 's' : ''}`;
        }
        if (remainingSeconds > 0) {
            result += `${minutes > 0 ? ' and ' : ''}${remainingSeconds}`;
            result += ` second${remainingSeconds > 1 ? 's' : ''}`;
        }
    }

    if (timeFormat === 'hours') {
        const minutes = Math.floor(seconds / 60);
        const remainingMinutes = Math.floor(seconds % 60);
        const hours = Math.floor(minutes / 60);
        const remainingSeconds = seconds % 60;

        if (hours > 0) {
            result += `${hours}`;
            result += ` hour${hours > 1 ? 's' : ''}`;
        }
        if (minutes > 0) {
            if (minutes >= 60) {
                if (remainingMinutes > 0) {
                    result += `${hours > 0 ? ' and ' : ''}${remainingMinutes}`;
                    result += ` minute${minutes > 1 ? 's' : ''}`;
                }
            } else {
                result += `${hours > 0 ? ' and ' : ''}${minutes}`;
                result += ` minute${minutes > 1 ? 's' : ''}`;
            }
        }
        if (remainingSeconds > 0) {
            result += `${(minutes > 0 || hours > 0) ? ' and ' : ''}${remainingSeconds}`;
            result += ` second${remainingSeconds > 1 ? 's' : ''}`;
        }
    }

    return result;
};